import axios from "axios";
import { AlenAccessToken } from "../authService";

export const WYND_USER_AGENT = "Wynd_Web_App";
const ALEN_API_URL = process.env.REACT_APP_ALEN_API_URL;

export const makeAlenAxios = (alenAccess: AlenAccessToken) => {
  if (!alenAccess.token) {
    throw new Error("Alen access token is missing");
  }
  return axios.create({
    baseURL: ALEN_API_URL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-api-key": alenAccess["x-api-key"],
      token: alenAccess.token,
      "x-user-agent": WYND_USER_AGENT,
    },
  });
};
